import { createContext } from "react";
import socketio from "socket.io-client";
import { API_URL } from "../config/host";

export const socket = socketio.connect(API_URL);
export const SocketContext = createContext()